<h2 mat-dialog-title>{{ data.isEdit ? 'Edit RRE' : 'Add RRE' }}</h2>

<mat-dialog-content>
	<form [formGroup]="form" class="rre-form">
		<mat-form-field appearance="outline">
			<mat-label>RRE</mat-label>
			<input
				matInput
				formControlName="rre"
				maxlength="9"
				inputmode="numeric"
				autocomplete="off"
				placeholder="XXXXXXXXX"
				(input)="onRreInput($event)"
				(blur)="onRreBlur()"
			/>
			<mat-hint align="end">{{ form.controls.rre.value.length }}/9</mat-hint>
			<mat-error *ngIf="showRreError && form.controls.rre.hasError('required')">
				RRE is required.
			</mat-error> 
			<mat-error *ngIf="showRreError && form.controls.rre.hasError('pattern')">
				RRE must be exactly 9 digits.
			</mat-error>
		</mat-form-field>

		<mat-form-field appearance="outline">
			<mat-label>RRE Name</mat-label>
			<input matInput formControlName="rreName" maxlength="70" />
			<mat-hint align="end">{{ form.controls.rreName.value.length }}/70</mat-hint>
			<mat-error *ngIf="form.controls.rreName.invalid && (form.controls.rreName.dirty || form.controls.rreName.touched)">
				RRE Name is required.
			</mat-error>
			<mat-error *ngIf="form.controls.rreName.hasError('maxlength') && (form.controls.rreName.dirty || form.controls.rreName.touched)">
				RRE Name cannot exceed 70 characters.
			</mat-error>
		</mat-form-field>

		<mat-form-field appearance="outline">
			<mat-label>Reporting Period</mat-label>
			<mat-select formControlName="reportingPeriod">
				<mat-option *ngFor="let period of reportingPeriods" [value]="period">{{ period }}</mat-option>
			</mat-select>
		</mat-form-field>

		<mat-checkbox formControlName="queryReportingOn">Query Reporting On?</mat-checkbox>

		<mat-checkbox formControlName="claimReportingOn">Claim Reporting On?</mat-checkbox>

		<mat-checkbox formControlName="isocpAccountDesigneeOnly">ISO CP Account Designee Only?</mat-checkbox>

		<mat-form-field appearance="outline" class="comment-field">
			<mat-label>Comment</mat-label>
			<textarea matInput formControlName="comment" rows="4" maxlength="250"></textarea>
			<mat-hint align="end">{{ form.controls.comment.value.length }}/250</mat-hint>
			<mat-error *ngIf="form.controls.comment.hasError('maxlength') && (form.controls.comment.dirty || form.controls.comment.touched)">
				Comment cannot exceed 250 characters.
			</mat-error>
		</mat-form-field>
	</form>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-flat-button color="primary" type="button" (click)="onSubmit()">{{ data.isEdit ? 'Update' : 'Submit' }}</button>
	<button mat-stroked-button type="button" (click)="onCancel()">Cancel</button>
</mat-dialog-actions>
